import React, { useState, useEffect, PureComponent } from "react";
import moment from "moment";
import { Modal, Button, Tabs, Checkbox, TextArea, IconChevronUp, IconChevronDown ,TextBox} from "@veneer/core";
import SpecialConditionDetailTypes3_14 from "./SpecialConditionDetailTypes3_14";
import SpecialConditionDetailTypes4 from "./SpecialConditionDetailTypes_4";
import SpecialConditionDetailTypes2_12 from "./SpecialConditionDetailTypes2_12";
import SpecialConditionAdditionalInformation from "./SpecialConditionAdditionalInformation";
import SpecialConditionDetailTypes_7 from "./SpecialConditionDetailTypes_7";
import SpecialConditionDetailTypes_1 from "./SpecialConditionDetailTypes_1";
import SpecialConditionDetailTypes_16 from "./SpecialConditionDetailTypes_16";
import SpecialConditionDetailTypes_22 from "./SpecialConditionDetailTypes_22";
import SpecialConditionDetailTypes_21 from "./SpecialConditionDetailTypes_21";
import { authenticationService } from "../../../services/context/AuthService";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend, } from "recharts";
import Swal from "sweetalert2";
import ApprovalConfirmationModal from "./InformationModal";
import { Row, Col, Container } from 'react-bootstrap';


const connectApi = new ConnectAPI();

function SpecialConditionDetail({ onShowModal, onCloseSCDetailsModal, SpecialConditionDetail, setidSC, dateSelectedCC }) {
    const { t } = useTranslation();
    const [ChangeButton,setChageButton]=useState(true);
    const [datahistory,setdatahistory]=useState([]);
    const [buttonModify, setButtonModify]=useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [notes, setNotes]=useState("");
    const [showModal, setShowModal] = useState(false);
    const [dataForModal, setDataFormModal] = useState([]);
    const [flowStatus, setFlowStatus] = useState("");
    const [specialConditionCC, setSpecialConditionCC] = useState([]);

    const approverSPCallback = (status, data) => {
        let date = new Date(Date.parse(SpecialConditionDetail.endDate));
        let short_Date= t('month' + (date.getMonth()+1).toString()) + "/"+date.getFullYear()
        SpecialConditionDetail.endDate=short_Date;
        setShowModal(true);
        let ids = []
        ids.push(SpecialConditionDetail.idSpecialCondition);
        setFlowStatus(data!=""?(data):(""));
        setDataFormModal(ids);
        onCloseSCDetailsModal();
    }
    const saveSpecialCondition=()=>{
        let payload = {
            specialConditionsList: [],
            email: authenticationService.currentUserValue.email,
            status: 'Approved'
        }
        let data={
            payload:payload,
            SpecialCondition:SpecialConditionDetail,
            old_endDate:"0"
        }
        connectApi.post( 'api/Channels/SaveSpecialCondition', data, approverSPCallback );
    }
    const deactivateModal = () => { setShowModal(false); }

    let specialConditionTypeId = SpecialConditionDetail.idSpecialConditionType;
    const [effectiveMonths, setEffectiveMonths] = useState(0)
    const increaseEndDate = (e) => {
        let date = new Date(Date.parse(SpecialConditionDetail.startDate));
        date.setMonth(date.getMonth() + parseInt((e-1)));
        date.setDate(lastday(date.getFullYear(), date.getMonth()));
        setEndDate( moment(new Date( new Date(date).getFullYear(), new Date(date).getMonth()+1, 0 )).format("MMM/YYYY") );
        SpecialConditionDetail.endDate=moment(date).format("DD/MMM/YYYY");
    }
    const [endDate, setEndDate] = useState("")

    var lastday = function(y,m){
        return  new Date(y, m +1, 0).getDate();
    }
    useEffect(()=>{
        if(SpecialConditionDetail != ''){
            calc_initial_effectivemont();
            get_history();

            if(authenticationService.currentUserValue.idRole != 1) {
                let listNotes = (SpecialConditionDetail.notes + "").split(";");
                if( listNotes.length > 1 ) setNotes(listNotes[1]);
            } else {
                setNotes(SpecialConditionDetail.notes);
            }

            const datesLoad = (status, data) => {
                const items = data.map((item) => {
                return {
                    value: moment(item.date).format("YYYY-MM-DDTHH:mm:ss"),
                    label: moment(item.date).format("MMM") + " " + moment(item.date).format("YYYY"),
                };
                });
                const date = items[0] === undefined ? null : items[0].value;
                setDateSelected(date);
            };
            connectApi.get("api/Channels/reports/Dates/", 
                "", 
                datesLoad
            ).catch((error) => {
                Swal.fire(
                "Error " + error.response.status,
                error.response.data,
                "error"
                );
            });

            const consolid_CombineCliks= (status, data) => { 
                if( data.length > 0 )
                    setSpecialConditionCC(data);
                else
                    Swal.fire("Error ", t("NoDatasc"), "error" );
            }

            if( (SpecialConditionDetail.idSpecialConditionType == 7 || SpecialConditionDetail.idSpecialConditionType == 8) && dateSelectedCC != undefined ){
                let dataCC={
                    date:dateSelectedCC,
                    idSC:SpecialConditionDetail.idSpecialCondition,
                    idEndUser:SpecialConditionDetail.idEndUser,
                }
                connectApi.post(
                    'api/Channels/specialConditionCombineClicks',
                    dataCC,
                    consolid_CombineCliks
                );
            }
        }
    },[SpecialConditionDetail.idSpecialCondition]);

    const get_history=()=>{
        connectApi.getWithParams("api/Channels/get_tpi_history",SpecialConditionDetail.idSpecialCondition , get_data_history)
        .catch((error) => {
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        })
    }
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    const get_data_history=(status, data)=>{
        data.forEach(obj => {
            obj.monthYear = moment(obj.monthYear).format("DD/MMM/YYYY");
            obj.bonus=parseInt(obj.bonus,10);
            obj.bonusAmount=parseFloat(parseFloat(obj.bonusAmount).toFixed(2));
            obj.compensation=parseFloat(obj.compensation);
            obj.tpi_prom=parseInt(obj.tpi_prom,10);
            obj.creditNotes=parseFloat(parseFloat(obj.creditNotes).toFixed(2));
        });
        data.reverse();
        setdatahistory(data);
    }
    
    
    function calc_initial_effectivemont(){
        var initial=0;
        setEndDate(SpecialConditionDetail.endDate);
        var date_start = moment(SpecialConditionDetail.startDate);
        var date_end = moment(SpecialConditionDetail.endDate);
        initial=date_end.diff(date_start, 'months');
        initial=initial+1;
        setEffectiveMonths(initial);
        
    }
    const specialConditionType = () => {
        //type 1: Maximum cost per print - type 13: Maximum CPP LS Mark
        if (specialConditionTypeId == 1 || specialConditionTypeId == 13   || specialConditionTypeId==26) {
            return <SpecialConditionDetailTypes_1 specialCondition={SpecialConditionDetail} />
        } //type 15: Maximum Cost Per Print - XRate - type 18: Maximum CPP - Rebate
        if (specialConditionTypeId == 16 || specialConditionTypeId==18) {
            return <SpecialConditionDetailTypes_16 specialCondition={SpecialConditionDetail} />
        } //type 3: Fixed Bonus - type 14 Fixed Bonus + EPM
        if (specialConditionTypeId == 3 || specialConditionTypeId == 14 || specialConditionTypeId == 25) {
            return <SpecialConditionDetailTypes3_14 specialCondition={SpecialConditionDetail} />
        } //type 4: Tiers Up
        if (specialConditionTypeId == 4) {
            return <SpecialConditionDetailTypes4 specialCondition={SpecialConditionDetail} />
        } //type 2: Bonus Special Table - type 12: Bonus Special Table + EPM - type 15: Bonus Special Table - All Imp
        if (specialConditionTypeId == 2 || specialConditionTypeId == 12 || specialConditionTypeId == 15) {
            return <SpecialConditionDetailTypes2_12 specialCondition={SpecialConditionDetail}/>
        } //type 7: Combine clicks - type 17: Combine Clicks + Spl Tbl EPM - type 8: Combine Clicks + Special Table - type 19: Combine Clicks + Tiers Up
        if (specialConditionTypeId == 7 || specialConditionTypeId == 8 || specialConditionTypeId == 17 || specialConditionTypeId == 19) {
            return <SpecialConditionDetailTypes_7 specialCondition={SpecialConditionDetail} />
        } // Type 11 Minimum Discount
        if (specialConditionTypeId == 11) {
            return SpecialConditionDetail.Percentage;
        } //type 21: Run Length
        if (specialConditionTypeId == 21 ) {
            return <SpecialConditionDetailTypes_21 specialCondition={SpecialConditionDetail} />
        } //type 22: Maximum CPP - LS Discount - type 23: Low Coverage Program
        if (specialConditionTypeId == 22 || specialConditionTypeId == 23) {
            return <SpecialConditionDetailTypes_22 specialCondition={SpecialConditionDetail} />
        }
    }

    const newPress = () => {
        if (SpecialConditionDetail.newPress == true) {
            return <Checkbox
                defaultChecked
                id="newPress-checkbox-checked"
                label="New Press"
                disabled
            />
        }
    }

    const newEndUser = () => {
        if (SpecialConditionDetail.newEndUser == true) {
            return <Checkbox
                defaultChecked
                id="newEndUser-checkbox-checked"
                label="New End User"
                disabled
            />
        }
    }
    const [selectedTabIdDefault, setSelectedTabIdDefault] = useState(0);
    class CustomizedAxisTick extends PureComponent {
        render() {
          const { x, y, stroke, payload } = this.props;
      
          return (
            <g transform={`translate(${x},${y})`}>
              <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
                {payload.value}
              </text>
            </g>
          );
        }
    }

    const modifyDate = (operation, number) => {
        if ( effectiveMonths+number >= 1 & effectiveMonths+number <= 999 & new Date(moment(endDate).subtract(-number, 'M')) >= new Date(dateSelected)){
            if ( effectiveMonths+number === effectiveMonths )
                setChageButton(true);
            else
                setChageButton(false);
            if (operation==='add')
                setEffectiveMonths(effectiveMonths+number);
            else if (operation==='sub')
                if( new Date(moment(endDate).subtract(-number, 'M')) >= new Date(SpecialConditionDetail.startDate) )
                    setEffectiveMonths(effectiveMonths+number);
            increaseEndDate(effectiveMonths+number);
        }
        
    }
    
    let list=[{
        id: 0, label: 'Basic Information', content: <div style={{ padding: '30px' }}>
            <div>
                {newPress()}
            </div>
            <div>
                {newEndUser()}
            </div>
            <div>
                Special Condition Id: {SpecialConditionDetail.idSpecialCondition}
            </div>
            <div>
                Channel: {SpecialConditionDetail.customerName}
            </div>
            <div>
                EndUser Name: {SpecialConditionDetail.endUserName}
            </div>
            <div>
                OPD #: {SpecialConditionDetail.opd}
            </div>
            {(SpecialConditionDetail.status=="Pending")?(
                <div>
                    Current Approved Level: {SpecialConditionDetail.approvalLevel}
                </div>
            ):("")}
            <div>
                Press: {SpecialConditionDetail.idPress}
            </div>
            <div>
                Special condition Type: {SpecialConditionDetail.specialConditionType}
            </div>
            <div>
                Start date: {SpecialConditionDetail.startDate}
            </div>
            {(window.location.pathname=="/Cpp/SpecialConditionReport")?(
                (authenticationService.currentUserValue.idRole==1 || authenticationService.currentUserValue.idRole==6||authenticationService.currentUserValue.idRole==13)?(
                    (SpecialConditionDetail.status=="Active" || SpecialConditionDetail.status=="Standby")?(
                        <div>
                            {buttonModify ? (
                                <Row className="align-items-center">
                                    
                                    <Col xs="auto">
                                       Effective Months:
                                    </Col>
                                    <Col xs="1">
                                        <Button 
                                            leadingIcon={<IconChevronUp />} 
                                            onClick={() => { modifyDate('add', 1); }} 
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <TextBox
                                            id="effectivemonthtext"
                                            value={effectiveMonths}
                                            style={{ width: '60px' }}
                                            onChange={(e) => {
                                                if (e >= 1 && e <= 999 && new Date(moment(endDate).subtract(-e, 'M')) >= new Date(dateSelected)) {
                                                    setChageButton(e === effectiveMonths);
                                                    if (new Date(moment(endDate).subtract(-e, 'M')) >= new Date(SpecialConditionDetail.startDate)) {
                                                        setEffectiveMonths(e);
                                                    }
                                                    increaseEndDate(e);
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col xs="1">
                                        <Button 
                                            leadingIcon={<IconChevronDown />} 
                                            onClick={() => { modifyDate('sub', -1); }} 
                                        />
                                    </Col>

                                </Row>
                            ) : ("")}
                        </div>
                    ):("")
                    
                ):("")
                
            ):("")
            }
            <div>
                End date: {endDate}
            </div>
            {specialConditionType()}
            <div>
                <TextArea
                    id="text-area-uncontrolled"
                    label="Notes"
                    disabled={true}
                    value={notes}
                />
            </div>
        </div>
    }]
    if (authenticationService.currentUserValue.idRole==11 || authenticationService.currentUserValue.idRole==12){
        
    }else{
        list.push({
            id: 1, label: 'Additional Information', content: <div style={{ padding: '30px' }}><SpecialConditionAdditionalInformation specialCondition={SpecialConditionDetail} /></div>
        });
    }
    if(SpecialConditionDetail.status=="Active" || SpecialConditionDetail.status=="InActive"){
        list.push({
            id:2,
            label:'Evolution',
            content:
            <div style={{padding:'30px'}}>
                <LineChart width={700} height={250} data={datahistory} margin={{ top: 5, right: 20, bottom: 10, left: 20 }}>
                    <Line yAxisId="left" key="tpi_prom" type="monotone" activeDot={{ r: 4 }}  dataKey="tpi_prom" name="TPI" stroke="#a76fff"/>
                    {(SpecialConditionDetail.idPress.substring(0, 1)=="5")?(""):(
                        <Line yAxisId="right" key="bonus" type="monotone" activeDot={{ r: 4 }} dataKey="bonus" name="Bonus Percentage" stroke="#307060" />
                    )}
                    <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
                    <XAxis dataKey="monthYear" height={60} tick={<CustomizedAxisTick />}  />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right" />
                    <Tooltip />
                    <Legend />
                </LineChart>
               {
               (authenticationService.currentUserValue.idRole==9 || authenticationService.currentUserValue.idRole==10 || authenticationService.currentUserValue.idRole==11 || authenticationService.currentUserValue.idRole==12 )?(""):(
                (SpecialConditionDetail.idPress)?(
                    (SpecialConditionDetail.idPress.substring(0, 1)=="4")?(
                        <LineChart width={650} height={250} data={datahistory} margin={{ top: 5, right: 20, bottom: 5, left: 20 }}>
                            <Line
                                key="creditNotes"
                                type="monotone"
                                activeDot={{ r: 8 }}
                                dataKey="creditNotes"
                                name="Credit Note"
                                stroke="#307060"
                            />
                            <Line
                                key="bonusAmount"
                                type="monotone"
                                activeDot={{ r: 8 }}
                                dataKey="bonusAmount"
                                name="Bonus"
                                stroke="#a7ff55"
                            />
                                
                            <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
                            <XAxis dataKey="monthYear" height={60} tick={<CustomizedAxisTick />}  />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                        </LineChart>
                        ):((SpecialConditionDetail.idPress.substring(0,1)=="5")?(
                            <LineChart width={650} height={250} data={datahistory} margin={{ top: 5, right: 20, bottom: 5, left: 20 }}>
                                <Line
                                    key="compensation"
                                    type="monotone"
                                    activeDot={{ r: 8 }}
                                    dataKey="compensation"
                                    name="Compensation"
                                    stroke="#307060"
                                />
                                <CartesianGrid stroke="#eee" strokeDasharray="3 3" />
                                <XAxis dataKey="monthYear" height={60} tick={<CustomizedAxisTick />}  />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                            </LineChart>
                            ):(""))
                        
                    ):("")
                )}
            </div>
        });
    }
    if( (SpecialConditionDetail.idSpecialConditionType == 7 || SpecialConditionDetail.idSpecialConditionType == 8) && dateSelectedCC != undefined && specialConditionCC.length != 0 ){
        list.push({
            id:3,
            label:'Combine Clicks Table',
            content:
            <div style={{padding:'30px'}}>
                <table className="table table-striped table-hover table-bordered" >
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">
                                {t("endUserName")}
                            </th>
                            <th scope="col" className="text-center">
                                {t("allTPI")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {specialConditionCC.map((row, index)=>{
                            return (<tr>
                                {row.idEnduser=='Total TPI\'s'?
                                (<>
                                    <td scope='col' className="text-right"><strong>{row.idEnduser}</strong></td>
                                    <td scope='col' className="text-right"><strong>{Number(row.tpiMonth).toLocaleString()}</strong></td>
                                </>):(<>
                                    <td scope='col' className="text-center">{row.idEnduser}</td>
                                    <td scope='col' className="text-right">{Number(row.tpiMonth).toLocaleString()}</td>
                                </>)
                                }
                            </tr>)
                        })}
                    </tbody>
                </table>
            </div>
        });
    }
    return (
        <>            
            <Modal
                id="regular-modal"
                onClose={() => { onCloseSCDetailsModal(); setButtonModify(false); setChageButton(true); }}
                show={onShowModal}
                css={{
                    '.vn-modal--content': {
                        width: "800px !important"
                    },
                  }}
                title="Special Condition Detail"
                
            >
                <Tabs
                    controlId="default"
                    onChangeTab={setSelectedTabIdDefault}
                    selectedTabId={selectedTabIdDefault}
                    tabs={list}
                />
                
                
                {(window.location.pathname.includes("/Cpp/SpecialConditionReport"))?(
                    (authenticationService.currentUserValue.idRole==1 || authenticationService.currentUserValue.idRole==6 || authenticationService.currentUserValue.idRole==13)?(
                        (SpecialConditionDetail.status=="Active" || SpecialConditionDetail.status=="Standby")?buttonModify?(
                            <Button  disabled={ChangeButton} onClick={() => {setButtonModify(false); saveSpecialCondition()}} > {t("save_button")}</Button>
                        ) : ( <Button onClick={() => setButtonModify(true)} > {t("modify")} </Button> ) : ("")
                    ):("")
                    
                ):("")
                }
            </Modal>

        <ApprovalConfirmationModal onHideModel={deactivateModal} isModalShowing={showModal} data={dataForModal} status={flowStatus } setidSC={setidSC} />
        </>
    );
}

export default SpecialConditionDetail;